"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var clause_1 = require("./clause");
var Builder = /** @class */ (function (_super) {
    __extends(Builder, _super);
    function Builder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Builder.prototype.prefix = function () {
        var _this = this;
        var prefixes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            prefixes[_i] = arguments[_i];
        }
        prefixes.map(function (prefix) {
            _this.addClause(prefix);
        });
        return this;
    };
    Builder.prototype.select = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var select = new clause_1.Select();
        items.map(function (item) {
            select.addComponent(item);
        });
        return this.addClause(select);
    };
    Builder.prototype.where = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var where = new clause_1.Where();
        items.map(function (item) {
            where.addComponent(item);
        });
        return this.addClause(where);
    };
    Builder.prototype.graph = function (iri) {
        var items = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            items[_i - 1] = arguments[_i];
        }
        var graph = new clause_1.Graph(iri);
        items.map(function (item) {
            graph.addComponent(item);
        });
        return this.addClause(graph);
    };
    Builder.prototype.orderBy = function (fields, direction) {
        return this.addClause(new clause_1.OrderBy(fields, direction));
    };
    Builder.prototype.groupBy = function (fields) {
        return this.addClause(new clause_1.GroupBy(fields));
    };
    Builder.prototype.limit = function (limit) {
        return this.addClause(new clause_1.Limit(limit));
    };
    Builder.prototype.offset = function (offset) {
        return this.addClause(new clause_1.Offset(offset));
    };
    return Builder;
}(clause_1.Clause));
exports.Builder = Builder;
